import React from 'react';
import {connect} from 'react-redux';
import {formatDateString14digits, formatTimeString14digits} from 'app/utilities/StringHelpers/StringHelpers';
import {downloadFile} from 'app/utilities/fileHelper';
const WorkOrderDetails = (props) => {
  const details = props.businessWorkOrderSystem.currentPopupData.fuDetails || [];
  const fuFiles = props.businessWorkOrderSystem.currentPopupData.fuFiles || [];

  const fileDetails =
    fuFiles.length > 0
      ? [
          {
            'קבצים מצורפים': (
              <div>
                {fuFiles.map((file, index) => (
                  <button className='fu-data-value-link' onClick={() => downloadFile(file.base64Content, file.fileName, file.type)}>
                    {file.fileName}.{file.type}
                  </button>
                ))}
              </div>
            ),
          },
        ]
      : [];

  const allDetails = [...details, ...fileDetails];

  const mid = Math.ceil(allDetails.length / 2);
  const firstColumn = allDetails.slice(0, mid);
  const secondColumn = allDetails.slice(mid);

  return (
    <div className='fu-details-container'>
      <div className='l-title'>פניה מספר {props.businessWorkOrderSystem.currentPopupData.fuId}</div>
      <div
        className={`m-title fu_status ${
          props.businessWorkOrderSystem.currentPopupData.fuStatusDescription != 'סגור' ? 'in_progress' : 'closed'
        }`}>
        <span>{props.businessWorkOrderSystem.currentPopupData.fuStatusDescription != 'סגור' ? 'בטיפול' : 'טופל'}</span>
      </div>

      <div className='fu-details'>
        <div className='general-data'>
          <div className='general-fu-data'>
            <div className='general-fu-data-column'>
              <div className='fu-data-item'>
                <div className='fu-data-label'>פותח הפניה </div>
                <div className='fu-data-value'>{props.businessWorkOrderSystem.currentPopupData.openedBy || '----'}</div>
              </div>
              <div className='fu-data-item'>
                <div className='fu-data-label'> סוג הפניה</div>
                <div className='fu-data-value'>{props.businessWorkOrderSystem.currentPopupData.futpSystemTxt}</div>
              </div>
            </div>
            <div className='general-fu-data-column'>
              <div className='fu-data-item'>
                <div className='fu-data-label'> תאריך פתיחה</div>
                <div className='fu-data-value'>
                  {formatDateString14digits(props.businessWorkOrderSystem.currentPopupData.fuOpenDate)},{' '}
                  {formatTimeString14digits(props.businessWorkOrderSystem.currentPopupData.fuOpenDate)}
                </div>
              </div>

              <div className='fu-data-item'>
                <div className='fu-data-label'> תאריך סגירה</div>
                <div className='fu-data-value'>
                  {props.businessWorkOrderSystem.currentPopupData.fuCloseDate && (
                    <span>
                      {formatDateString14digits(props.businessWorkOrderSystem.currentPopupData.fuCloseDate)},{' '}
                      {formatTimeString14digits(props.businessWorkOrderSystem.currentPopupData.fuCloseDate)}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='buffer-data'>
          <div className='general-fu-data'>
            <div className='general-fu-data-column title-column'>
              <div className='fu-data-item'>
                <div className='fu-data-value'>פירוט הפניה</div>
              </div>
            </div>
            <div className='general-fu-data-column'></div>
          </div>

          <div className='general-fu-data'>
            <div className='general-fu-data-column'>
              {firstColumn.map((detail, index) => {
                const [key, value] = Object.entries(detail)[0];
                return (
                  <div key={index} className='fu-data-item'>
                    <div className='fu-data-label'>{key}</div>
                    <div className='fu-data-value'>{value}</div>
                  </div>
                );
              })}
            </div>
            <div className='general-fu-data-column'>
              {secondColumn.map((detail, index) => {
                const [key, value] = Object.entries(detail)[0];
                return (
                  <div key={index} className='fu-data-item'>
                    <div className='fu-data-label'>{key}</div>
                    <div className='fu-data-value'>{value}</div>
                  </div>
                );
              })}
              {secondColumn.length % 2 !== 0 && <div className='fu-data-item'></div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  businessWorkOrderSystem: state.businessWorkOrderSystem,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderDetails);
